import tw from 'twin.macro'

export const Container = tw.div`
  flex
  flex-wrap
  gap-[8px]
`
